import React from 'react';
import { Typography } from '@mui/material';
import { geoLine } from '../location/profile/LocationProfileSEO';

interface SearchResultsHeadingProps {
  city: string;
  state: string;
}

/**
 * The city search page's only heading. Crawlers previously saw a page with no
 * H1 at all, so Google preferred a single yard over the city list for
 * "truck parking in <city>" queries. Same wording as the location page's geo
 * line and the meta description, so page text and snippet agree. Deliberately
 * one line: on phones every extra line pushes the first result further down.
 */
const SearchResultsHeading = ({ city, state }: SearchResultsHeadingProps) => (
  <Typography component="h1" sx={{ fontWeight: 600, fontSize: '1.125rem', lineHeight: 1.3, px: 2, pt: 1, pb: 0.5 }}>
    {geoLine(city, state)}
  </Typography>
);

export default SearchResultsHeading;
